<template>
    <div class="chat-content">
        <div
            v-for="asset in entry.attachments"
            class="chat-entry chat-entry-asset"
            :class="groupDirection === 'out' ? `bg-primary text-white` : 'bg-white'"
        >
            <div class="active-chat-asset">
                <b-img-lazy
                    v-if="asset.category === 'image'"
                    v-b-modal="`modal-${asset.fileName}`"
                    :src="getFullPath(asset)"
                    :alt="asset.originalName"
                />

                <!-- TEMP SOLUTION! NEEDS MEDIA QUERIES WIDTH -->
                <div v-if="asset.category === 'video'" style="width: 280px">
                    <b-embed type="video" :src="getFullPath(asset)" controls allowfullscreen> </b-embed>
                </div>

                <template v-if="asset.category === 'audio'">
                    <div v-if="audioError" class="error">
                        <p>{{ $t("audio_error") }}</p>
                        <a download :href="getFullPath(asset)">
                            <button>{{ $t("Download") }}</button>
                        </a>
                    </div>
                    <audio v-else controls>
                        <source :src="getFullPath(asset)" @error="onAudioError" />
                    </audio>
                </template>

                <b-modal
                    :id="`modal-${asset.fileName}`"
                    ok-only
                    :ok-title="$t('Close')"
                    centered
                    size="lg"
                    :title="asset.originalName"
                    header-close-variant="light"
                >
                    <div class="text-center mb-1">
                        <b-img fluid :src="getFullPath(asset)" :alt="asset.originalName" />
                    </div>
                    <p v-if="entry.caption" class="text-center mb-1">{{ entry.caption }}</p>

                    <div class="d-flex justify-content-center">
                        <b-button class="text-center" variant="light" @click="localDownloadFile(asset)"
                            >{{ $t("Download") }}
                        </b-button>
                    </div>
                </b-modal>

                <template v-if="asset.category === 'application' && asset.originalName">
                    <p class="download-text">
                        <b-link class="download-text" @click="localDownloadFile(asset)">
                            <font-awesome-icon
                                size="xl"
                                :icon="resolveContentTypeIcon(asset.contentType)"
                                @click="localDownloadFile(asset)"
                            />
                            {{ asset.originalName }}
                        </b-link>
                        <span v-if="entry.caption"> <br />{{ entry.caption }} </span>
                    </p>
                </template>

                <template v-else-if="entry.caption">
                    <p class="chat-entry-content">{{ entry.caption }}</p>
                </template>
            </div>

            <small class="chat-time" :class="groupDirection === 'out' ? ['text-white', 'text-shadow'] : ''">
                {{
                    formatDate(entry.createdAt, {
                        hour: "2-digit",
                        minute: "2-digit",
                    })
                }}
                <font-awesome-icon
                    v-if="status && groupDirection === 'out' && resolveMessageStatusIcon(status)"
                    v-b-tooltip.hover.right="status"
                    class="ml-50"
                    :class="status !== 'delivered' ? ['text-white', 'svg-shadow'] : 'text-secondary'"
                    :icon="resolveMessageStatusIcon(status)"
                />
            </small>
        </div>
    </div>
</template>

<script>
import { BImg, BImgLazy, BButton, BModal, VBModal, BEmbed, BLink, VBTooltip } from "bootstrap-vue";
import { useToast } from "vue-toastification/composition";
import i18n from "@/libs/i18n";
import { resolveMessageStatusIcon, resolveMessageStatusClass, resolveContentTypeIcon } from "@/utils/chats";
import { getFullPath, downloadFile } from "@/utils/assets";
import { resolveTemplateButtonIcon } from "@/utils/templates";
import { resolvePlatformColor, supportsMessageStatusUpdates } from "@/utils/channels";
import { formatDate } from "@/utils/luxon";

export default {
    components: {
        BImg,
        BImgLazy,
        BButton,
        BModal,
        BEmbed,
        BLink,
    },
    directives: {
        "b-modal": VBModal,
        "b-tooltip": VBTooltip,
    },
    props: {
        entry: {
            type: Object,
            required: true,
        },
        groupDirection: {
            type: String,
            required: true,
        },
        formattedActiveChatData: {
            type: Array,
            required: true,
        },
        status: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            audioError: false,
        };
    },
    setup() {
        const toast = useToast();

        const localDownloadFile = (asset) => {
            return downloadFile(asset).catch(() => toast.error(i18n.t("toast.read.error")));
        };

        return {
            formatDate,
            getFullPath,
            localDownloadFile,
            resolveContentTypeIcon,
            resolveMessageStatusClass,
            resolveMessageStatusIcon,
            resolvePlatformColor,
            resolveTemplateButtonIcon,
            supportsMessageStatusUpdates,
        };
    },
    methods: {
        onAudioError() {
            this.audioError = true;
        },
    },
};
</script>

<style>
.chat-app-window .active-chat-log .chat-body .chat-content .embed-responsive {
    min-width: 370px;
}
</style>
